<template>
  <div>
    <b-navbar
      class="navbar navbar-dark bg-dark fixed-top"
      toggleable="md"
      variant="dark"
      v-bind:class="{ 'fixed-top': window.isMobile }"
    >
      <b-navbar-brand href="#" v-on:click="int_DoInLiao++">{{
        $t("Navbar.WebSiteName")
      }}</b-navbar-brand>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item v-bind:to="'/ViewMaps'">{{
            $t("Navbar.ViewMaps")
          }}</b-nav-item>
          <b-nav-item v-bind:to="'/AllTaiwan'">{{
            $t("Navbar.AllTaiwan")
          }}</b-nav-item>
          <b-nav-item v-bind:to="'/EachRegion'">{{
            $t("Navbar.EachRegion")
          }}</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="showQA = true">{{
            $t("Navbar.Usage")
          }}</b-nav-item>
          <b-nav-item-dropdown class="dropdown-menu-right" right>
            <template slot="button-content" right>
              <i class="material-icons" style="font-size: 20px">language</i>
            </template>
            <b-dropdown-item @click="changeLanguage('zh_tw')"
              >繁體中文</b-dropdown-item
            >
            <b-dropdown-item @click="changeLanguage('en')"
              >English</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-modal
      v-model="showQA"
      :title="$t('Navbar.Usage')"
      ok-only
      size="lg"
      id="modalQA"
    >
      <div class="content">
        <div>
          <div class="paragraph">
            <div class="title">{{ $t("Usage.GoalOfPredict.title") }}</div>
            <div class="item">{{ $t("Usage.GoalOfPredict.item") }}</div>
          </div>
          <div class="paragraph">
            <div class="title">{{ $t("Usage.HowToUse.title") }}</div>
            <div class="item">
              <ol style="list-style-type: decimal; font-weight: 600;">
                <li>
                  {{ $t("Usage.HowToUse.item.ViewMaps.title") }}
                  <ul style="padding-left: 14px; font-weight: 400;  ">
                    <li>{{ $t("Usage.HowToUse.item.ViewMaps.item1") }}</li>
                    <li>{{ $t("Usage.HowToUse.item.ViewMaps.item2") }}</li>
                  </ul>
                </li>
                <li>
                  {{ $t("Usage.HowToUse.item.AllTaiwan.title") }}
                  <ul style="padding-left: 14px; font-weight: 400;">
                    <li>{{ $t("Usage.HowToUse.item.AllTaiwan.item1") }}</li>
                    <li>{{ $t("Usage.HowToUse.item.AllTaiwan.item2") }}</li>
                    <li>{{ $t("Usage.HowToUse.item.AllTaiwan.item3") }}</li>
                  </ul>
                </li>
                <li>
                  {{ $t("Usage.HowToUse.item.EachRegion.title") }}
                  <ul style="padding-left: 14px; font-weight: 400;">
                    <li>{{ $t("Usage.HowToUse.item.EachRegion.item1") }}</li>
                  </ul>
                </li>
              </ol>
            </div>
          </div>

          <div class="paragraph">
            <div class="title">
              {{ $t("Usage.AccuracyOfPredict.title") }}
            </div>
            <div class="item">
              {{ $t("Usage.AccuracyOfPredict.item1.describe1")
              }}<span style="font-family: MathJax_Math-italic;">n</span
              >{{ $t("Usage.AccuracyOfPredict.item1.describe2") }}
              <ul style="list-style-type: circle;">
                <li>
                  {{ $t("Usage.AccuracyOfPredict.item2.MAPE.title") }}
                  <span ref="formula_1" class="e-mathjax">
                    $${1 \over n} {\sum\limits_{i=1}^n{|1-{
                    {{ $t("Usage.AccuracyOfPredict.item2.MAPE.item1") }} \over
                    {{ $t("Usage.AccuracyOfPredict.item2.MAPE.item2") }}}|}}
                    *100\% .$$
                  </span>
                </li>
                <li>
                  {{ $t("Usage.AccuracyOfPredict.item2.HitRate.title") }}

                  <span ref="formula_2" class="e-mathjax">
                    $${1 \over n} {\sum\limits_{i=1}^n{(sign({{
                      $t("Usage.AccuracyOfPredict.item2.HitRate.item1")
                    }}-{{
                      $t("Usage.AccuracyOfPredict.item2.HitRate.item2")
                    }})=sign({{
                      $t("Usage.AccuracyOfPredict.item2.HitRate.item3")
                    }}-{{
                      $t("Usage.AccuracyOfPredict.item2.HitRate.item4")
                    }})).}}$$
                  </span>
                  {{ $t("Usage.AccuracyOfPredict.item2.HitRate.item5") }}
                  <span style="font-family: MathJax_Math-italic;">sign(x)</span
                  >{{ $t("Usage.AccuracyOfPredict.item2.HitRate.item6") }}
                </li>
              </ul>
            </div>
          </div>

          <div class="paragraph">
            <div class="title">{{ $t("Usage.Resource.title") }}</div>
            <div class="item">{{ $t("Usage.Resource.describe") }}</div>
            <div class="item">
              <ul style="list-style-type: circle;">
                <li>
                  {{ $t("Usage.Resource.item1") }} (<a
                    href="https://data.cdc.gov.tw/dataset/rods-influenza"
                    target="blank"
                    >{{ $t("Usage.Resource.opendata") }}</a
                  >)
                </li>
                <li>
                  {{ $t("Usage.Resource.item2") }} (<a
                    href="https://data.cdc.gov.tw/dataset/hi-outpatient-emergency-visit-influenza"
                    target="blank"
                    >{{ $t("Usage.Resource.opendata") }}</a
                  >)
                </li>
                <!-- <li>{{$t('Usage.Resource.item3')}}<a href="https://nidss.cdc.gov.tw/" target="blank">{{$t('Usage.Resource.item4')}}</a>{{$t('Usage.Resource.item5')}}</li> -->
              </ul>
            </div>
          </div>

          <div class="paragraph">
            <div class="title">{{ $t("Usage.ModelList.title") }}</div>
            <div class="item">
              <ul style="list-style-type: circle;">
                <li>{{ $t("Usage.ModelList.Ensemble") }}</li>
                <li>{{ $t("Usage.ModelList.ARIMA") }}</li>
                <li>{{ $t("Usage.ModelList.RF") }}</li>
                <li>{{ $t("Usage.ModelList.SVR") }}</li>
                <li>{{ $t("Usage.ModelList.XGB") }}</li>
                <!--
                <li>ARIMA：<span class="u b">A</span>uto<span class="u b">r</span>egressive <span class="u b">I</span>ntegrated <span class="u b">M</span>oving <span class="u b">A</span>verage model，差分整合移動平均自迴歸模型。</li>
                <li>RF： <span class="u b">R</span>andom <span class="u b">F</span>orest，隨機森林模型。</li>
                <li>SVR：<span class="u b">S</span>upportive <span class="u b">V</span>ector <span class="u b">R</span>egression，支持向量迴歸模型。</li>
                <li>XGB：E<span class="u b">x</span>treme <span class="u b">G</span>radient <span class="u b">B</span>oosting模型。</li>
                -->
              </ul>
            </div>
          </div>
          <div class="paragraph">
            <div class="title">{{ $t("Usage.Acknowledgements.title") }}</div>
            <div class="item">{{ $t("Usage.Acknowledgements.item") }}</div>
          </div>
          <div class="paragraph">
            <div class="title">{{ $t("Usage.Notice.title") }}</div>
            <div
              class="item"
              v-html="$t('Usage.Notice.itemWithoutNotice')"
            ></div>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn
          size="sm"
          class="float-right"
          variant="primary"
          @click="showQA = false"
        >
          {{ $t("OK") }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "Vue";
export default {
  name: "Navbar",
  data() {
    return {
      window: window,
      showQA: false,
      int_DoInLiao: 0,
      showLanguage: this.$getCookie("showLanguage")
    };
  },
  methods: {
    changeLanguage: function(lang) {
      // console.log(this)
      // console.log(Vue)
      // console.log(lang)
      this.$setCookie("language", lang);
      location.reload();
    }
  },
  watch: {
    showQA: function() {
      if (this.showQA) this.$ga.page("/QA");
      window.MathJax.typesetPromise();
    },
    int_DoInLiao: function() {
      if (this.int_DoInLiao == 5) {
        this.$setCookie("showLanguage", true);
        this.showLanguage = this.$getCookie("showLanguage");
        console.warn("Language Support.");
      }
    }
  },
  mounted: function() {}
};
</script>

<style lang="scss" scoped>
.navbar {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  z-index: 5;
}
.content {
  font-size: 14px;
  max-height: calc(100vh - 240px);
  overflow-y: scroll;
  padding: 16px;
  .paragraph {
    padding-bottom: 8px;
    .title {
      font-weight: 600;
      font-size: 16px;
    }
    .u {
      text-decoration: underline;
    }
    .b {
      font-weight: bold;
    }
    .r {
      color: rgb(244, 67, 54);
    }
  }
}

.content::-webkit-scrollbar {
  width: 12px;
  height: 8px;
}

.content::-webkit-scrollbar-thumb {
  background-color: rgba(109, 109, 109, 0.3);
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1),
    inset 0 -1px 0 rgba(0, 0, 0, 0.07);
}

ol,
ul {
  margin-bottom: 0px;
}
</style>
<style>
#modalQA___BV_modal_body_ {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue